import type { DimensionBreakdownReportItem } from './model';
import Badge, { type BadgeColor } from '@/components/common/Badge';

interface DimensionBreakdownReportProps {
    title: string;
    items: DimensionBreakdownReportItem[];
}

const DimensionBreakdownReport = ({ title, items }: DimensionBreakdownReportProps) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="pdf-avoid-break bg-neutral-0 rounded-xl">
            <div className="rounded-t-xl bg-neutral-100 px-5 py-4">
                <p className="text-base font-semibold text-neutral-800">{title}</p>
            </div>
            <div className="flex flex-col gap-5 pb-5">
                {items.map((item, idx) => (
                    <div key={item.category}>
                        {idx > 0 && <hr className="border-neutral-200" />}
                        <div className="flex flex-col gap-2.5 px-5 pt-5">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2.5">
                                    <span className="text-base font-semibold text-neutral-800">{item.category}</span>
                                    {item.label && (
                                        <Badge text={item.label} color={(item.badgeColor as BadgeColor) ?? 'gray'} />
                                    )}
                                </div>
                                <span className="text-base font-bold text-neutral-800">{item.score}</span>
                            </div>
                            {item.description && (
                                <p className="text-base leading-normal text-neutral-500">{item.description}</p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DimensionBreakdownReport;
